/**
 * @generated SignedSource<<261cad5b30367f2060b0057c0724e8e5>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    type: string;
    inlineResolveProperties: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_User =
  {
    __typename?: "User";
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author =

    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author_User;
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User =
  {
    __typename?: "User";
    permissionType: SitePermissionType | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author =

    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User;
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    type: string;
    inlineResolveProperties: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location =

    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment
    | UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment;
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment =
  {
    __typename?: "Comment";
    id: string;
    author: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author;
    createdAt: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_createdAt_ConfluenceDate;
    location: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location;
  };
export type UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment = {
  __typename?: "Comment";
  id: string;
  location: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_location;
  author: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_author;
  createdAt: UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate;
  replies: Array<UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment | null>;
};
export type UnreadCommentQuery_comments_PaginatedCommentList = {
  __typename?: "PaginatedCommentList";
  totalCount: number | null;
  nodes: Array<UnreadCommentQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
};
export type UnreadCommentQuery_Query = {
  __typename?: "Query";
  comments: UnreadCommentQuery_comments_PaginatedCommentList | null;
};
export type UnreadCommentQueryVariables = Exact<{
  pageId: Scalars["ID"]["input"];
  contentStatus?: InputMaybe<
    Array<InputMaybe<GraphQLContentStatus>> | InputMaybe<GraphQLContentStatus>
  >;
}>;
export type UnreadCommentQuery = UnreadCommentQuery_Query;
